export default {
  ADVANCE: 'ADVANCE',
  ADVANCE_DEPOSIT: 'ADVANCE_DEPOSIT',
  VENUE: 'VENUE',
  NONE: 'NONE',
}



// WEBPACK FOOTER //
// ./src/constants/bookingPaymentTypes.js